import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Modes from './Modes.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import MeasurementTable from './MeasurementTable.json';
import PanelSUV from './PanelSUV.json';
import SidePanel4D from './SidePanel4D.json'
import Messages from './Messages.json';
import SegmentationTable from './SegmentationTable.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import Modals from './Modals.json';
import PatientInfo from './PatientInfo.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Dropdowns from './Dropdowns.json';
import WindowLevelActionMenu  from './WindowLevelActionMenu.json';
import DicomTagBrowser from './DicomTagBrowser.json';
import Cookies from './Cookies.json';

export default {
  es: {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    PanelSUV,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    Modals,
    PatientInfo,
    HotkeysValidators,
    MeasurementTable,
    Messages,
    Cookies,
    SegmentationTable,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    Modes,
    Dropdowns,
    WindowLevelActionMenu,
    DicomTagBrowser,
    SidePanel4D
  },
};
